import React from 'react';
import PropTypes from 'prop-types';

import {track, getPageTrackingInfo, setPageTrackingInfo} from './helper';
import SiteInfoTracker from './tracker-site-info';
import UserInfoTracker from './tracker-user-info';

class TrackingProvider extends React.Component {
  static childContextTypes = {
    track: PropTypes.object,
    getPageTrackingInfo: PropTypes.func,
    setPageTrackingInfo: PropTypes.func,
  };

  // TODO: React upgrade will deprecate getChildContext 16.3+
  getChildContext() {
    return {
      track,
      getPageTrackingInfo,
      setPageTrackingInfo,
    };
  }

  render() {
    const {children} = this.props;

    return (
      <>
        <SiteInfoTracker />
        <UserInfoTracker />
        {children}
      </>
    );
  }
}

TrackingProvider.propTypes = {
  children: PropTypes.node,
};
export default TrackingProvider;
